import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { ServiceProviderFormSchemaValues } from 'src/features/serviceProvider/utils/formSchema';
import { organisationMessages } from 'src/features/serviceProvider/utils/messages';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { generalMessages } from 'src/utils/messages';

type ServiceProviderFormProps = {
    form: UseFormReturn<ServiceProviderFormSchemaValues>;
    onSubmit: (values: ServiceProviderFormSchemaValues) => void;
};
function ServiceProviderForm({ onSubmit, form }: ServiceProviderFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ServiceProviderFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(generalMessages.name)}
            />
            <InputFormField<ServiceProviderFormSchemaValues>
                form={form}
                name="uic"
                label={formatMessage(organisationMessages.uic)}
            />
            <InputFormField<ServiceProviderFormSchemaValues>
                form={form}
                name="tax_number"
                label={formatMessage(organisationMessages.taxNumber)}
            />
            <InputFormField<ServiceProviderFormSchemaValues>
                form={form}
                name="legal_address"
                label={formatMessage(organisationMessages.address)}
            />
            <InputFormField<ServiceProviderFormSchemaValues>
                form={form}
                name="representative"
                label={formatMessage(organisationMessages.legalRepresentative)}
            />
        </Form>
    );
}

export default ServiceProviderForm;
